import { Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import { renderField, required } from '../../common/helpers/form-validations';
import { notifySet } from '../../Services/Actions/CommonActions';
import { STATUS_MSG } from '../../Services/config/globals';
import { getCategories, serviceProviderList } from '../../Services/Utils/ServiceProviderApis';
import styles from '../UserDetails/MyProfile.module.css';

function PlanForm(props) {
  const {
    handleSubmit, onButtonClick, planText, buttonSaveText,
    invalid, submitSucceeded, pristine, serviceProviders, setServiceProviders
  } = props;
  const dispatch = useDispatch();

  const onSubmit = (formData) => {
    if (serviceProviders.length === 0) {
      dispatch(notifySet({ type: 'error', message: STATUS_MSG.serviceProviderRequired }));
    } else {
      onButtonClick(formData);
    }
  };

  useEffect(() => {
    getServiceProviderCategory();
    getSpecialServiceProviders();
  }, []);

  const [categories, setCategories] = useState();
  const [ssProviders, setSSProviders] = useState();

  const getServiceProviderCategory = () => {
    const params = {
      start: 0,
      recordSize: '',
    };
    getCategories({ active: true }, params, 'private').then(async (responseJson) => {
      const { list, hasError, message } = responseJson;
      if (hasError === false) {
        setCategories(list);
      } else {
        dispatch(notifySet({ type: 'error', message }));
      }
    });
  };

  const getSpecialServiceProviders = () => {
    const params = {
      start: 0,
      recordSize: '',
    };
    const request = {
      status: {
        id: 4
      }
    };
    serviceProviderList(request, params).then(async (responseJson) => {
      const { list, hasError, message } = responseJson;
      if (hasError === false) {
        setSSProviders(list);
      } else {
        dispatch(notifySet({ type: 'error', message }));
      }
    });
  };

  const handleSelectItem = (e, item) => {
    e.preventDefault();
    const findSP = serviceProviders.find((selectedItem) => selectedItem.id === item.id);
    if (findSP) {
      setServiceProviders(serviceProviders.filter((selectedItem) => Number(selectedItem.id) !== Number(item.id)));
    } else {
      setServiceProviders([...serviceProviders, item]);
    }
  };

  return (
    <div>
      <form form="categoryForm" onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-6">
            <h6>{planText}</h6>
            <div className="form-group">
              <label htmlFor="serviceprovidername">
                Name <span className="validation-icon">*</span>
              </label>
              <Field
                component={renderField}
                type="text"
                name="name"
                validate={[required]}
                id="name"
                className="form-control"
                placeholder="Enter name"
              />
            </div>
          </div>
          <div className="col-lg-12">
            <div className="form-group">
              <label htmlFor="serviceProviders">
                Select Service Partners <span className="validation-icon">*</span>
              </label>
            </div>
            {categories?.map((category, key) => (
              <div
                key={key}
                className={`${styles['tag-btn-title-list-col']} ${styles.smaller}`}
              >
                <div className="row">
                  <div className="col-sm-12 col-md-2 col-lg-2">
                    <div className={`${styles['tag-btn-title-list-title']}`}>
                      <h6 className="sm-tag-font">{category.name}</h6>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-10 col-lg-10">
                    <div className="tag-btn-title-list-tag">
                      <div className={`${styles['tag-btn-menu-ul-con']}`}>
                        <ul>
                          {category.serviceProviderViews?.map((deals, Categorykey) => {
                            const findSP = serviceProviders.find((selectedItem) => selectedItem.id === deals.id);
                            return (
                              <li key={Categorykey}>
                                <Link
                                  onClick={(e) => handleSelectItem(e, { id: deals.id, name: deals.name })}
                                  className={findSP ? `${styles['selected-items']}` : ''}
                                >
                                  {deals.name}
                                </Link>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            <div className={`${styles['tag-btn-title-list-col']} ${styles.smaller}`}>
              <div className="row">
                <div className="col-sm-12 col-md-2 col-lg-2">
                  <div className={`${styles['tag-btn-title-list-title']}`}>
                    <h6 className="sm-tag-font">Others</h6>
                  </div>
                </div>
                <div className="col-sm-12 col-md-10 col-lg-10">
                  <div className="tag-btn-title-list-tag">
                    <div className={`${styles['tag-btn-menu-ul-con']}`}>
                      <ul>
                        {ssProviders?.map((ssProvider, key) => {
                          const findSP = serviceProviders.find((selectedItem) => selectedItem.id === ssProvider.id);
                          return (
                            <li key={key}>
                              <Link
                                onClick={(e) => handleSelectItem(e, { id: ssProvider.id, name: ssProvider.name })}
                                className={findSP ? `${styles['selected-items']}` : ''}
                              >
                                {ssProvider.name}
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Button
              type="submit"
              className="btn btn-red"
              disabled={invalid || submitSucceeded || pristine}
            >
              {buttonSaveText}
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
}

const withForm = reduxForm({
  enableReinitialize: true,
  form: 'planForm',
});

export default withForm(PlanForm);
